import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Practice from './routes/Practice';
import PrivacyPolicy from './routes/PrivacyPolicy';
import AppPrivacyPolicy from './routes/AppPrivacyPolicy';
import VerificationData from './routes/VerificationData';
import reportWebVitals from './reportWebVitals';

const API_URL = "https://api.quetracker.com"

const handleBackToMenu = () => window.location.href = '/';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App API_URL={API_URL} />} />
        <Route path="/getVerificationData" element={<VerificationData API_URL={API_URL} />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy handleBackToMenu={handleBackToMenu} />} />
        <Route path="/appPrivacyPolicy" element={<AppPrivacyPolicy handleBackToMenu={handleBackToMenu} />} />
        <Route path="/practice" element={<Practice />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
